import { Button, BUTTON_WIDTH } from '@websrc/App/Components/Button/Button'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { useBasketStateOptional } from '@websrc/Basket/useBasketState'
import React from 'react'

import * as SC from './CartModalFooter.style'

export const CartModalFooter = () => {
  const t = useStaticText()
  const locale = useLocale()
  const basketState = useBasketStateOptional()

  return (
    <SC.Wrapper>
      <SC.SubtotalWrapper>
        <SC.SubtotalLabel>{t.shopping_cart.subtotal}</SC.SubtotalLabel>
        <SC.SubtotalLabel>{basketState?.subtotal}</SC.SubtotalLabel>
      </SC.SubtotalWrapper>
      <SC.ButtonWrapper>
        <Button
          color={'black'}
          colorMode={'light'}
          data-link-name={'cta-minibasket-gotocheckout'}
          href={`/${locale}/checkout/cart`}
          onClick={() =>
            matomo.trackEvent(
              'engagement',
              'mini_basket',
              [t.shopping_cart.your_cart],
              [t.shopping_cart.view_cart],
              'button'
            )
          }
          size={'medium'}
          text={t.shopping_cart.view_cart}
          type={'primary'}
          width={BUTTON_WIDTH.Full}
        />
        <Button
          color={'black'}
          colorMode={'light'}
          data-link-name={'cta-minibasket-gotoquote'}
          href={`/${locale}/checkout/cart#quote`}
          onClick={() =>
            matomo.trackEvent(
              'engagement',
              'mini_basket',
              [t.shopping_cart.your_cart],
              [t.shopping_cart.request_a_quote],
              'button'
            )
          }
          size={'medium'}
          text={t.shopping_cart.request_a_quote}
          type={'secondary'}
          width={BUTTON_WIDTH.Full}
        />
      </SC.ButtonWrapper>
    </SC.Wrapper>
  )
}
